var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("article", [
    _c(
      "div",
      [
        _c("qrcode-vue", {
          attrs: {
            value: _vm.value,
            size: _vm.size,
            level: _vm.level,
            margin: _vm.margin,
            background: _vm.background,
            foregroung: _vm.foreground
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }